import { render, staticRenderFns } from "./myPrize.vue?vue&type=template&id=10d75660&scoped=true&"
import script from "./myPrize.vue?vue&type=script&lang=js&"
export * from "./myPrize.vue?vue&type=script&lang=js&"
import style0 from "./myPrize.vue?vue&type=style&index=0&id=10d75660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d75660",
  null
  
)

export default component.exports